import { getOrigin } from "./getOrigin";

export const getCurrentScriptOrigin = (): string | undefined => {
  const currentScript = document.currentScript as HTMLScriptElement;
  if (currentScript && currentScript.src) {
    return getOrigin(currentScript.src);
  }
  return undefined;
};
